export const AUTO_REPLY_DATE_FORMAT = 'YYYY-MM-DD';
